import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonRequest } from '../../models/common/common.request';

@Injectable()
export class AccountService {

    constructor(private apiService: ApiService) { }


    // ------------- role controller start -------------

    getRoles(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`roles`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }

    getRole(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`roles/management`, commonRequest).pipe(map(
            roleResponse => {
                if (roleResponse) {
                    return roleResponse;
                } else {
                    throw throwError(roleResponse.error);
                }
            },
        ));
    }
    createRole(roleRequest: any): Observable<any> {
        return this.apiService.post(`roles/management`, roleRequest).pipe(map(
            roleResponse => {
                if (roleResponse) {
                    return roleResponse;
                } else {
                    throw throwError(roleResponse.error);
                }
            },
        ));
    }
    updateRole(roleRequest: any, id: any): Observable<any> {
        return this.apiService.put(`roles/management/${id}`, roleRequest).pipe(map(
            roleResponse => {
                if (roleResponse) {
                    return roleResponse;
                } else {
                    throw throwError(roleResponse.error);
                }
            },
        ));
    }
    deleteRole(roleRequest: any): Observable<any> {
        return this.apiService.delete(`roles/management/${roleRequest.id}`, roleRequest).pipe(map(
            roleResponse => {
                if (roleResponse) {
                    return roleResponse;
                } else {
                    throw throwError(roleResponse.error);
                }
            },
        ));
    }


    getRolesList(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`roles/management`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }

    getRoleManagementList(commonRequest: CommonRequest, id: any): Observable<any> {
        return this.apiService.get(`roles/management/${id}`, commonRequest).pipe(map(
            roleResponse => {
                if (roleResponse) {
                    return roleResponse;
                } else {
                    throw throwError(roleResponse.error);
                }
            },
        ));
    }
    // ---------------------- Role Controller End ----------------------


    // ------------ Screen Operation Management Controller Start ------------

    getScreenMgmtList(commonRequest: CommonRequest, id: any): Observable<any> {
        return this.apiService.get(`screen-operation/mgmt/${id}`, commonRequest).pipe(map(
            screeMgmtResponse => {
                if (screeMgmtResponse) {
                    return screeMgmtResponse;
                } else {
                    throw throwError(screeMgmtResponse.error);
                }
            },
        ));
    }

    updateScreenMgmtList(screenRequest: any): Observable<any> {
        return this.apiService.put(`screen-operation/mgmt`, screenRequest)
            .pipe(map(
                screeMgmtResponse => {
                    if (screeMgmtResponse) {
                        return screeMgmtResponse;
                    } else {
                        throw throwError(screeMgmtResponse.error);
                    }
                },
            ));
    }
    getOperationsListForScreenOp(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`screen-operation/mgmt/operation`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }

    createOperation(request: any): Observable<any> {
        return this.apiService.post(`screen-operation/mgmt/operation`, request).pipe(map(
            roleResponse => {
                if (roleResponse) {
                    return roleResponse;
                } else {
                    throw throwError(roleResponse.error);
                }
            },
        ));
    }
    // ------------------- Screen Operation Management Controller End --------------------







    // ----------------- Screen Management Controller Start ---------------

    getScreen(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`screen-management`, commonRequest).pipe(map(
            screenResponse => {
                if (screenResponse) {
                    return screenResponse;
                } else {
                    throw throwError(screenResponse.error);
                }
            },
        ));
    }
    createScreen(screenRequest: any): Observable<any> {
        return this.apiService.post(`screen-management`, screenRequest).pipe(map(
            screenResponse => {
                if (screenResponse) {
                    return screenResponse;
                } else {
                    throw throwError(screenResponse.error);
                }
            },
        ));
    }
    updateScreen(screenRequest: any, id: any): Observable<any> {
        return this.apiService.put(`screen-management/${id}`, screenRequest).pipe(map(
            screenResponse => {
                if (screenResponse) {
                    return screenResponse;
                } else {
                    throw throwError(screenResponse.error);
                }
            },
        ));
    }
    deleteScreen(screenRequest: any): Observable<any> {
        return this.apiService.delete(`screen-management/${screenRequest.id}`, screenRequest).pipe(map(
            screenResponse => {
                if (screenResponse) {
                    return screenResponse;
                } else {
                    throw throwError(screenResponse.error);
                }
            },
        ));
    }

    getOperationsListForScreenMngt(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`screen-management/operation`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }

    getScreenManagementList(commonRequest: CommonRequest, id: any): Observable<any> {
        return this.apiService.get(`screen-management/${id}`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }


    getScreenList(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`screen-management`, commonRequest).pipe(map(
            screenResponse => {
                if (screenResponse) {
                    return screenResponse;
                } else {
                    throw throwError(screenResponse.error);
                }
            },
        ));
    }
    // ----------------- Screen Management Controller Start ---------------


    // --------------------- Users Controller Stert ------------------
    getUsers(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`users`, commonRequest).pipe(map(
            usersResponse => {
                if (usersResponse) {
                    return usersResponse;
                } else {
                    throw throwError(usersResponse.error);
                }
            },
        ));
    }
    createUser(userRequest: any): Observable<any> {
        return this.apiService.post(`users`, userRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }
    updateUser(userRequest: any, id: any): Observable<any> {
        return this.apiService.put(`users/${id}`, userRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }
    addUserCredits(id: any, count: number): Observable<any> {
        return this.apiService.post(`users/${id}/credits`, { count }).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }
    deleteUser(userRequest: any): Observable<any> {
        return this.apiService.delete(`users/${userRequest.id}`, userRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    updateProfile(profileRequest: any, id: any): Observable<any> {
        return this.apiService.put(`users/edit-profile/${id}`, profileRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    getClientSecret(commonRequest: any): Observable<any> {
        return this.apiService.get(`users/get-credentials`, commonRequest).pipe(map(
            usersResponse => {
                if (usersResponse) {
                    return usersResponse;
                } else {
                    throw throwError(usersResponse.error);
                }
            },
        ));
    }

    generateClientSecret(commonRequest: any): Observable<any> {
        return this.apiService.get(`users/generate/credentials`, commonRequest).pipe(map(
            usersResponse => {
                if (usersResponse) {
                    return usersResponse;
                } else {
                    throw throwError(usersResponse.error);
                }
            },
        ));
    }

    // --------------------- Users Controller END ------------------


   



    //-----------------------> LDAP Start <---------------------
    syncLdapUser(userRequest: any): Observable<any> {
        return this.apiService.post(`users/ldap/sync`, userRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    addLdapUser(ldapRequest: any): Observable<any> {
        return this.apiService.post(`users/ldap/add`, ldapRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    getSearchLdapUser(ldapSearchRequest: any): Observable<any> {
        return this.apiService.post(`users/ldap/search`, ldapSearchRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    getLdapConfig(ldapConfigRequest: any): Observable<any> {
        return this.apiService.post(`users/ldap/config`, ldapConfigRequest).pipe(map(
            ldapConfigResponse => {
                if (ldapConfigResponse) {
                    return ldapConfigResponse;
                } else {
                    throw throwError(ldapConfigResponse.error);
                }
            },
        ));
    }

    addLdapDetails(userRequest: any): Observable<any> {
        return this.apiService.post(`ldap/add-details`, userRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    testLdapConnection(userRequest: any): Observable<any> {
        return this.apiService.post(`ldap/test`, userRequest).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }


    getLdapDetails(ldapConfigRequest: any): Observable<any> {
        return this.apiService.get(`ldap/details`, ldapConfigRequest).pipe(map(
            ldapConfigResponse => {
                if (ldapConfigResponse) {
                    return ldapConfigResponse;
                } else {
                    throw throwError(ldapConfigResponse.error);
                }
            },
        ));
    }

    loadAdGroups(request: any): Observable<any> {
        return this.apiService.post(`ldap/groups/tree`, request).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    pageLdapGroupUsers(request: any): Observable<any> {
        return this.apiService.post(`ldap/groups/users/page`, request).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    syncLdapGroup(request: any): Observable<any> {
        return this.apiService.post(`ldap/groups/sync`, request).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    unsyncLdapUser(request: any): Observable<any> {
        return this.apiService.post(`ldap/users/unsync`, request).pipe(map(
            userResponse => {
                if (userResponse) {
                    return userResponse;
                } else {
                    throw throwError(userResponse.error);
                }
            },
        ));
    }

    

    genrateUUID(commonRequest: CommonRequest): Observable<any> {
        console.log(commonRequest);
        return this.apiService.get(`commons/generate-uuid`, commonRequest).pipe(map(
            serverResponse => {
                if (serverResponse) {
                    return serverResponse;
                } else {
                    throw throwError(serverResponse.error);
                }
            },
        ));
    }


    generateOtp(otpRequest: any): Observable<any> {
        return this.apiService.post(`generateOTP`, otpRequest).pipe(map(
            otpResponse => {
                if (otpResponse) {
                    return otpResponse;
                } else {
                    throw throwError(otpResponse.error);
                }
            },
        ));
    }

    verifyOtp(verifyRequest: any): Observable<any> {
        return this.apiService.post(`validateOTP`, verifyRequest).pipe(map(
            verifyResponse => {
                if (verifyResponse) {
                    return verifyResponse;
                } else {
                    throw throwError(verifyResponse.error);
                }
            },
        ));
    }

    getListEnvironment(commonRequest: CommonRequest, id: any): Observable<any> {
        return this.apiService.get(`getCommonCodeList/${id}`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }

    getProfile(commonRequest: CommonRequest, id: any): Observable<any> {
        return this.apiService.get(`users/${id}`, commonRequest).pipe(map(
            usersResponse => {
                if (usersResponse) {
                    return usersResponse;
                } else {
                    throw throwError(usersResponse.error);
                }
            },
        ));
    }


    getMetadataByServerIp(commonRequest: any): Observable<any> {
        return this.apiService.post(`dashboard/server-ip`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }

    getMetadataByStatus(commonRequest: any): Observable<any> {
        return this.apiService.post(`dashboard/file-status`, commonRequest).pipe(map(
            commonResponse => {
                if (commonResponse) {
                    return commonResponse;
                } else {
                    throw throwError(commonResponse.error);
                }
            },
        ));
    }


    getDashboardServer(commonRequest: any): Observable<any> {
        return this.apiService.get(`dashboard/server-list`, commonRequest).pipe(map(
            usersResponse => {
                if (usersResponse) {
                    return usersResponse;
                } else {
                    throw throwError(usersResponse.error);
                }
            },
        ));
    }

    getTotalServerdata(commonRequest: any): Observable<any> {
        return this.apiService.get(`dashboard/server-data`, commonRequest).pipe(map(
            usersResponse => {
                if (usersResponse) {
                    return usersResponse;
                } else {
                    throw throwError(usersResponse.error);
                }
            },
        ));
    }


     // ------------------- Server Group Start ------------------

    getAllGroup(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`group`, commonRequest).pipe(map(
            groupResponse => {
                if (groupResponse) {
                    return groupResponse;
                } else {
                    throw throwError(groupResponse.error);
                }
            },
        ));
    }

    getUserGroups(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`group/user`, commonRequest).pipe(map(
            groupResponse => {
                if (groupResponse) {
                    return groupResponse;
                } else {
                    throw throwError(groupResponse.error);
                }
            },
        ));
    }

    createGroup(userRequest: any): Observable<any> {
        return this.apiService.post(`group`, userRequest).pipe(map(
            groupResponse => {
                if (groupResponse) {
                    return groupResponse;
                } else {
                    throw throwError(groupResponse.error);
                }
            },
        ));
    }
    updateGroup(userRequest: any, id: any): Observable<any> {
        return this.apiService.put(`group/${id}`, userRequest).pipe(map(
            groupResponse => {
                if (groupResponse) {
                    return groupResponse;
                } else {
                    throw throwError(groupResponse.error);
                }
            },
        ));
    }
    deleteGroup(userRequest: any): Observable<any> {
        return this.apiService.delete(`group/${userRequest.id}`, userRequest).pipe(map(
            groupResponse => {
                if (groupResponse) {
                    return groupResponse;
                } else {
                    throw throwError(groupResponse.error);
                }
            },
        ));
    }



    // -------------------- Ext License Key (extension) -------------------

    getAllExtKeys(commonRequest: CommonRequest, list?: any): Observable<any> {
        return this.apiService.get(`keys` + this.screenListQuery(list), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getKeySellPacks(): Observable<any> {
        return this.apiService.get(`keys/packs`, new CommonRequest()).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    addKeysForAccount(request: any): Observable<any> {
        return this.apiService.post(`keys/add`, request).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    generateExtKey(request: any): Observable<any> {
        return this.apiService.post(`keys/generate`, request).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    revokeExtKey(key: string): Observable<any> {
        return this.apiService.post(`keys/revoke`, { key }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    deleteExtKey(id: any): Observable<any> {
        return this.apiService.delete(`keys/${id}`, new CommonRequest()).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    updateExtKey(id: any, request: any): Observable<any> {
        return this.apiService.put(`keys/${id}`, request).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    // -------------------- App Accounts (desktop users) -------------------

    getDemoDevices(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`bookings/demo-devices`, commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getBookings(commonRequest: CommonRequest, list?: any): Observable<any> {
        return this.apiService.get(`bookings` + this.screenListQuery(list), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getGiveawayUsers(commonRequest: CommonRequest, date?: string, slot?: string, booking?: {
        fromStation?: string;
        toStation?: string;
        payment?: string;
        version?: string;
        client?: string;
        trainNo?: string;
        username?: string;
    }): Observable<any> {
        const params: string[] = [];
        if (booking?.username) {
            params.push('username=' + encodeURIComponent(booking.username));
        }
        if (date) {
            params.push('date=' + encodeURIComponent(date));
        }
        if (slot) {
            params.push('slot=' + encodeURIComponent(slot));
        }
        if (booking) {
            if (booking.fromStation) {
                params.push('fromStation=' + encodeURIComponent(booking.fromStation));
            }
            if (booking.toStation) {
                params.push('toStation=' + encodeURIComponent(booking.toStation));
            }
            if (booking.payment) {
                params.push('payment=' + encodeURIComponent(booking.payment));
            }
            if (booking.version) {
                params.push('version=' + encodeURIComponent(booking.version));
            }
            if (booking.client) {
                params.push('client=' + encodeURIComponent(booking.client));
            }
            if (booking.trainNo) {
                params.push('trainNo=' + encodeURIComponent(booking.trainNo));
            }
        }
        const q = params.length ? '?' + params.join('&') : '';
        return this.apiService.get(`giveaway` + q, commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    sendGiveawayKeys(telegramIds: string[]): Observable<any> {
        return this.apiService.post(`giveaway/send-keys`, { telegramIds }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getBookingTicket(id: any): Observable<any> {
        return this.apiService.get(`bookings/${id}/ticket`, new CommonRequest()).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getAllAppAccounts(commonRequest: CommonRequest, list?: any): Observable<any> {
        return this.apiService.get(`app-accounts` + this.screenListQuery(list), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    createAppAccount(request: any): Observable<any> {
        return this.apiService.post(`app-accounts`, request).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    addAppAccountCredits(id: any, request: any): Observable<any> {
        return this.apiService.post(`app-accounts/${id}/credits`, request).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    resetAppAccount(id: any): Observable<any> {
        return this.apiService.put(`app-accounts/${id}/reset`, {}).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    deleteAppAccount(id: any): Observable<any> {
        return this.apiService.delete(`app-accounts/${id}`, new CommonRequest()).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getDashboardSummary(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`app-dashboard/summary`, commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getDashboardBookings(commonRequest: CommonRequest, period: string, from?: string, to?: string, dateField?: string): Observable<any> {
        return this.apiService.get(this.dashboardUrl('app-dashboard/bookings', period, from, to, dateField), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getDashboardKeys(commonRequest: CommonRequest, period: string, from?: string, to?: string, keyStatus?: string, dateField?: string): Observable<any> {
        let url = this.dashboardUrl('app-dashboard/keys', period, from, to, dateField);
        if (keyStatus) {
            url += (url.includes('?') ? '&' : '?') + 'keyStatus=' + encodeURIComponent(keyStatus);
        }
        return this.apiService.get(url, commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getDashboardAccounts(commonRequest: CommonRequest, period: string, from?: string, to?: string, accountType?: string, dateField?: string): Observable<any> {
        let url = this.dashboardUrl('app-dashboard/accounts', period, from, to, dateField);
        if (accountType) {
            url += (url.includes('?') ? '&' : '?') + 'accountType=' + encodeURIComponent(accountType);
        }
        return this.apiService.get(url, commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getDashboardDemoLogins(commonRequest: CommonRequest, period: string, from?: string, to?: string, dateField?: string): Observable<any> {
        return this.apiService.get(this.dashboardUrl('app-dashboard/demo-logins', period, from, to, dateField), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    private screenListQuery(list?: any): string {
        if (!list || (!list.period && !list.username && !list.slot && !list.records && list.limit == null && !list.dateField)) {
            return '';
        }
        const q = [];
        if (list.period) {
            q.push('period=' + encodeURIComponent(list.period));
        }
        if (list.from) {
            q.push('from=' + encodeURIComponent(list.from));
        }
        if (list.to) {
            q.push('to=' + encodeURIComponent(list.to));
        }
        if (list.records) {
            q.push('records=' + encodeURIComponent(list.records));
        }
        if (list.limit) {
            q.push('limit=' + encodeURIComponent(String(list.limit)));
        }
        if (list.dateField) {
            q.push('dateField=' + encodeURIComponent(list.dateField));
        }
        if (list.username) {
            q.push('username=' + encodeURIComponent(list.username));
        }
        if (list.slot) {
            q.push('slot=' + encodeURIComponent(list.slot));
        }
        return q.length ? '?' + q.join('&') : '';
    }

    private dashboardUrl(path: string, period: string, from?: string, to?: string, dateField?: string): string {
        const q = ['period=' + encodeURIComponent(period || 'today')];
        if (from) {
            q.push('from=' + encodeURIComponent(from));
        }
        if (to) {
            q.push('to=' + encodeURIComponent(to));
        }
        if (dateField) {
            q.push('dateField=' + encodeURIComponent(dateField));
        }
        return path + '?' + q.join('&');
    }

    setAppUserBlocked(id: any, blocked: boolean, days?: number, reason?: string): Observable<any> {
        return this.apiService.put(`app-accounts/${id}/block`, { blocked, days, reason }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    listAppDevices(list?: any): Observable<any> {
        return this.apiService.get(`app-devices` + this.screenListQuery(list), new CommonRequest()).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    private paymentQuery(period?: string, from?: string, to?: string, sellerId?: number | string): string {
        const q = [`period=${encodeURIComponent(period || 'today')}`];
        if (from) {
            q.push(`from=${encodeURIComponent(from)}`);
        }
        if (to) {
            q.push(`to=${encodeURIComponent(to)}`);
        }
        if (sellerId) {
            q.push(`sellerId=${encodeURIComponent(String(sellerId))}`);
        }
        return '?' + q.join('&');
    }

    setAppDeviceBlocked(id: any, blocked: boolean, days?: number, reason?: string): Observable<any> {
        return this.apiService.put(`app-devices/${id}/block`, { blocked, days, reason }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getPaymentSummary(commonRequest: CommonRequest, period?: string, from?: string, to?: string, sellerId?: number | string): Observable<any> {
        return this.apiService.get(`payments/summary` + this.paymentQuery(period, from, to, sellerId), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getPaymentSellers(commonRequest: CommonRequest, period?: string, from?: string, to?: string): Observable<any> {
        return this.apiService.get(`payments/sellers` + this.paymentQuery(period, from, to), commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    raisePayment(amount: number): Observable<any> {
        return this.apiService.post(`payments/requests`, { amount }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    decidePayment(id: number, action: string, amount?: number): Observable<any> {
        return this.apiService.put(`payments/requests/${id}`, { action, amount }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    getAppConfig(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get('app-config/items', commonRequest).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

    saveAppConfig(items: { key: string; value: string }[]): Observable<any> {
        return this.apiService.put('app-config/items', { items }).pipe(map(
            res => {
                if (res) {
                    return res;
                } else {
                    throw throwError(res.error);
                }
            },
        ));
    }

}